/* tslint:disable */
/* eslint-disable */
/**
 * pinnacle-backend API spec
 * Backend Service for Pinnacle Underwriting | [swagger.json](pinnacle/swagger.json)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface TaxRateResponseDto
 */
export interface TaxRateResponseDto {
    /**
     * Market
     * @type {string}
     * @memberof TaxRateResponseDto
     */
    market: string;
    /**
     * Insured country
     * @type {string}
     * @memberof TaxRateResponseDto
     */
    insured: string;
    /**
     * Reinsured country code
     * @type {string}
     * @memberof TaxRateResponseDto
     */
    reinsured: string;
    /**
     * Broker country code
     * @type {string}
     * @memberof TaxRateResponseDto
     */
    broker: string;
    /**
     * Binder identifier
     * @type {string}
     * @memberof TaxRateResponseDto
     */
    binder: string;
    /**
     * Withholding tax rate as a decimal
     * @type {string}
     * @memberof TaxRateResponseDto
     */
    withholdingTax: string;
    /**
     * AIT tax rate as a decimal
     * @type {string}
     * @memberof TaxRateResponseDto
     */
    ait: string;
    /**
     * GST Premium tax rate as a decimal
     * @type {string}
     * @memberof TaxRateResponseDto
     */
    gstPremium: string;
    /**
     * GST Source Brokerage tax rate as a decimal
     * @type {string}
     * @memberof TaxRateResponseDto
     */
    gstSourceBrokerage: string;
    /**
     * ERE rate as a decimal
     * @type {number}
     * @memberof TaxRateResponseDto
     */
    ere: number;
}

/**
 * Check if a given object implements the TaxRateResponseDto interface.
 */
export function instanceOfTaxRateResponseDto(value: object): value is TaxRateResponseDto {
    if (!('market' in value) || value['market'] === undefined) return false;
    if (!('insured' in value) || value['insured'] === undefined) return false;
    if (!('reinsured' in value) || value['reinsured'] === undefined) return false;
    if (!('broker' in value) || value['broker'] === undefined) return false;
    if (!('binder' in value) || value['binder'] === undefined) return false;
    if (!('withholdingTax' in value) || value['withholdingTax'] === undefined) return false;
    if (!('ait' in value) || value['ait'] === undefined) return false;
    if (!('gstPremium' in value) || value['gstPremium'] === undefined) return false;
    if (!('gstSourceBrokerage' in value) || value['gstSourceBrokerage'] === undefined) return false;
    if (!('ere' in value) || value['ere'] === undefined) return false;
    return true;
}

export function TaxRateResponseDtoFromJSON(json: any): TaxRateResponseDto {
    return TaxRateResponseDtoFromJSONTyped(json, false);
}

export function TaxRateResponseDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): TaxRateResponseDto {
    if (json == null) {
        return json;
    }
    return {
        
        'market': json['market'],
        'insured': json['insured'],
        'reinsured': json['reinsured'],
        'broker': json['broker'],
        'binder': json['binder'],
        'withholdingTax': json['withholdingTax'],
        'ait': json['ait'],
        'gstPremium': json['gstPremium'],
        'gstSourceBrokerage': json['gstSourceBrokerage'],
        'ere': json['ere'],
    };
}

export function TaxRateResponseDtoToJSON(json: any): TaxRateResponseDto {
    return TaxRateResponseDtoToJSONTyped(json, false);
}

export function TaxRateResponseDtoToJSONTyped(value?: TaxRateResponseDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'market': value['market'],
        'insured': value['insured'],
        'reinsured': value['reinsured'],
        'broker': value['broker'],
        'binder': value['binder'],
        'withholdingTax': value['withholdingTax'],
        'ait': value['ait'],
        'gstPremium': value['gstPremium'],
        'gstSourceBrokerage': value['gstSourceBrokerage'],
        'ere': value['ere'],
    };
}

